import React, { useEffect, useState } from "react";
import styled from "styled-components";
import "../../Assets/Css/style.css";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../../Assets/Images/GirlsHub Template/Logo.png";
import { Input, Badge, Drawer, Space, Divider, Button } from "antd";
import {
  CloseOutlined,
  MenuOutlined,
  MobileFilled,
  SearchOutlined,
} from "@ant-design/icons";
import API from "../../ApiService/ApiService";
import { useDispatch } from "react-redux";
import { logoutUser } from "../../Redux/slices/user";

let cart = 0;

const Header10 = ({ home_custom }) => {
  // console.log("Header10--->", home_custom);

  const [wiseList, setWiseList] = useState([]);
  const [cart, setCart] = useState([]);
  const [mobileMenu, setMobileMenu] = useState(false);
  const [search, setSearch] = useState("");
  const [isSearchVisible, setIsSearchVisible] = useState(false);

  let token = localStorage.getItem("token") || "";
  let login = localStorage.getItem("login") || false;
  let userData = localStorage.getItem("user") || null;

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const api = new API();

  const logout = () => {
    //data of the user will be deleted from local storage after logout and also set null value to userSlice
    dispatch(logoutUser(null));
    // dispatch(emptyRemoveAddress(null));
    // dispatch(emptyUpdateAddress(null));
    // dispatch(emptyUserAddress(null));
    // localStorage.setItem("user", "");
    // localStorage.setItem("token", "");
    // localStorage.setItem("login", false);
    localStorage.clear();
    navigate("/");
    window.location.reload();
  };

  useEffect(() => {
    getAllCart();
    getAllWiseList();
  }, []);

  const getAllCart = () => {
    api
      .getcart()
      .then((res) => {
        // console.log("res", res);
        setCart(res?.data?.data);
      })
      .catch((err) => {
        // console.log("err", err);
        setCart([]);
      });
  };
  const getAllWiseList = () => {
    api
      .getWishList()
      .then((res) => {
        setWiseList(res?.data?.data);
      })
      .catch((err) => {
        setWiseList([]);
      });
  };

  const toogleSearch = () => {
    setIsSearchVisible(!isSearchVisible);
  };

  const handleSearch = () => {
    if (search !== "") {
      navigate(`/products?product_name=${search}`);
      setIsSearchVisible(false);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  return (
    <HeaderAlign>
      <div className="home_wrapper">
        <div className="Header_Main">
          <div className="Header_Left">
            <div className="Header_Logo">
              <Link to="/">
                <img src={Logo} alt="header-logo" />
              </Link>
            </div>
          </div>
          <div className="Header_Middle">
            <ul className="Header_List">
              <Link to="/" style={{ textDecoration: "none" }}>
                <li className="Header_Item">Home</li>
              </Link>
              <Link to="/about" style={{ textDecoration: "none" }}>
                <li className="Header_Item">About Us </li>
              </Link>
              <Link to="/products" style={{ textDecoration: "none" }}>
                <li className="Header_Item">Collections</li>
              </Link>
            </ul>
          </div>
          <div className="Header_Right">
            {login && token && userData ? (
              <div className="Header_Icons">
                <div
                  className="Search"
                  onClick={() => toogleSearch()}
                  style={{ cursor: "pointer" }}
                >
                  <svg
                    width="25"
                    height="25"
                    viewBox="0 0 40 39"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M35.1981 33.152L27.5243 25.551C29.7485 22.9056 30.8576 19.5125 30.6209 16.0776C30.3842 12.6426 28.8199 9.43035 26.2534 7.10894C23.687 4.78754 20.3159 3.53575 16.8416 3.61398C13.3672 3.6922 10.0571 5.09442 7.59972 7.52894C5.14236 9.96345 3.72698 13.2428 3.64802 16.6849C3.56906 20.1269 4.8326 23.4666 7.17579 26.0092C9.51898 28.5518 12.7614 30.1015 16.2286 30.3361C19.6957 30.5706 23.1207 29.4718 25.791 27.2683L33.4632 34.8708C33.5771 34.9836 33.7124 35.0731 33.8612 35.1342C34.0101 35.1953 34.1696 35.2267 34.3307 35.2267C34.4918 35.2267 34.6513 35.1953 34.8001 35.1342C34.949 35.0731 35.0842 34.9836 35.1981 34.8708C35.3121 34.7579 35.4024 34.6239 35.4641 34.4765C35.5257 34.329 35.5575 34.171 35.5575 34.0114C35.5575 33.8518 35.5257 33.6937 35.4641 33.5463C35.4024 33.3988 35.3121 33.2648 35.1981 33.152ZM6.13059 17.0057C6.13059 14.8435 6.77777 12.7299 7.99029 10.9321C9.20281 9.13427 10.9262 7.73306 12.9426 6.90563C14.9589 6.07819 17.1776 5.8617 19.3182 6.28352C21.4587 6.70534 23.425 7.74654 24.9682 9.27544C26.5115 10.8043 27.5624 12.7523 27.9882 14.8729C28.414 16.9936 28.1955 19.1917 27.3603 21.1893C26.5251 23.1869 25.1107 24.8942 23.296 26.0955C21.4814 27.2967 19.3479 27.9379 17.1654 27.9379C14.2398 27.9347 11.4349 26.7819 9.3662 24.7324C7.29747 22.6829 6.13383 19.9041 6.13059 17.0057Z"
                      fill="black"
                    />
                  </svg>
                </div>
                {isSearchVisible && (
                  <Input
                    type="text"
                    placeholder="Type your search here..."
                    onChange={(e) => setSearch(e.target.value)}
                    onKeyDown={handleKeyDown}
                    style={{
                      width: "200px",
                      height: "30px",
                      border: "none",
                      outline: "none",
                    }}
                  />
                )}
                <div className="MyProfile">
                  <Link to="/my-profile">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M16 3C13.4288 3 10.9154 3.76244 8.77759 5.1909C6.63975 6.61935 4.97351 8.64968 3.98957 11.0251C3.00563 13.4006 2.74819 16.0144 3.2498 18.5362C3.75141 21.0579 4.98953 23.3743 6.80762 25.1924C8.6257 27.0105 10.9421 28.2486 13.4638 28.7502C15.9856 29.2518 18.5995 28.9944 20.9749 28.0104C23.3503 27.0265 25.3807 25.3603 26.8091 23.2224C28.2376 21.0846 29 18.5712 29 16C28.9964 12.5533 27.6256 9.24882 25.1884 6.81163C22.7512 4.37445 19.4467 3.00364 16 3ZM9.26001 24.6875C9.98342 23.5561 10.98 22.625 12.1579 21.9801C13.3358 21.3351 14.6571 20.9971 16 20.9971C17.3429 20.9971 18.6642 21.3351 19.8421 21.9801C21.02 22.625 22.0166 23.5561 22.74 24.6875C20.8129 26.1862 18.4413 26.9999 16 26.9999C13.5587 26.9999 11.1871 26.1862 9.26001 24.6875ZM12 15C12 14.2089 12.2346 13.4355 12.6741 12.7777C13.1137 12.1199 13.7384 11.6072 14.4693 11.3045C15.2002 11.0017 16.0044 10.9225 16.7804 11.0769C17.5563 11.2312 18.269 11.6122 18.8284 12.1716C19.3878 12.731 19.7688 13.4437 19.9231 14.2196C20.0775 14.9956 19.9983 15.7998 19.6955 16.5307C19.3928 17.2616 18.8801 17.8864 18.2223 18.3259C17.5645 18.7654 16.7911 19 16 19C14.9391 19 13.9217 18.5786 13.1716 17.8284C12.4214 17.0783 12 16.0609 12 15ZM24.22 23.3013C23.1047 21.6851 21.5365 20.4348 19.7125 19.7075C20.6923 18.9358 21.4072 17.878 21.7579 16.6811C22.1086 15.4843 22.0776 14.2079 21.6693 13.0294C21.2609 11.851 20.4955 10.8291 19.4794 10.1059C18.4634 9.38262 17.2472 8.99397 16 8.99397C14.7528 8.99397 13.5366 9.38262 12.5206 10.1059C11.5045 10.8291 10.7391 11.851 10.3307 13.0294C9.92238 14.2079 9.8914 15.4843 10.2421 16.6811C10.5928 17.878 11.3077 18.9358 12.2875 19.7075C10.4635 20.4348 8.89529 21.6851 7.78001 23.3013C6.37072 21.7165 5.4496 19.7581 5.12756 17.6619C4.80553 15.5657 5.09631 13.4211 5.9649 11.4864C6.83349 9.55163 8.24285 7.90922 10.0233 6.75692C11.8037 5.60462 13.8792 4.99156 16 4.99156C18.1208 4.99156 20.1963 5.60462 21.9768 6.75692C23.7572 7.90922 25.1665 9.55163 26.0351 11.4864C26.9037 13.4211 27.1945 15.5657 26.8724 17.6619C26.5504 19.7581 25.6293 21.7165 24.22 23.3013Z"
                        fill="#000"
                      />
                    </svg>
                  </Link>
                </div>
                <div className="WishList">
                  <Link to="/wish-list" style={{ textDecoration: "none" }}>
                    <svg
                      width="25"
                      height="25"
                      viewBox="0 0 35 35"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M24.1926 4.3867C21.3862 4.3867 18.929 5.58233 17.3973 7.60332C15.8657 5.58233 13.4085 4.3867 10.602 4.3867C8.36799 4.3892 6.22622 5.2695 4.64654 6.83449C3.06687 8.39948 2.1783 10.5213 2.17578 12.7346C2.17578 22.1596 16.2815 29.7884 16.8822 30.1035C17.0406 30.1879 17.2175 30.2321 17.3973 30.2321C17.5771 30.2321 17.7541 30.1879 17.9124 30.1035C18.5131 29.7884 32.6189 22.1596 32.6189 12.7346C32.6163 10.5213 31.7278 8.39948 30.1481 6.83449C28.5684 5.2695 26.4266 4.3892 24.1926 4.3867ZM17.3973 27.9223C14.9157 26.4897 4.35029 19.9635 4.35029 12.7346C4.35244 11.0926 5.0118 9.51847 6.18375 8.35741C7.35571 7.19635 8.9446 6.54313 10.602 6.54099C13.2454 6.54099 15.4647 7.93589 16.3916 10.1764C16.4735 10.3739 16.6129 10.5429 16.7919 10.6618C16.971 10.7807 17.1817 10.8442 17.3973 10.8442C17.6129 10.8442 17.8236 10.7807 18.0027 10.6618C18.1818 10.5429 18.3211 10.3739 18.403 10.1764C19.3299 7.93185 21.5493 6.54099 24.1926 6.54099C25.85 6.54313 27.4389 7.19635 28.6109 8.35741C29.7828 9.51847 30.4422 11.0926 30.4443 12.7346C30.4443 19.9528 19.8763 26.4883 17.3973 27.9223Z"
                        fill="black"
                      />
                    </svg>
                  </Link>
                </div>
                <div className="Cart">
                  <Link to="/cart" style={{ textDecoration: "none" }}>
                    <Badge
                      count={cart?.cart_item?.length}
                      className="Cart_Badge"
                    >
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 27 34"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2.26328 14.2139L0.686641 29.428L2.70101 29.6692L4.27764 14.453L2.26328 14.2139ZM3.70819 33.0489H23.4992V30.8755H3.70819V33.0489ZM26.5208 29.428L24.9441 14.2139L22.9298 14.453L24.5064 29.6692L26.5208 29.428ZM21.9206 11.3146H5.28685V13.488H21.9246V11.3146H21.9206ZM24.9441 14.2139C24.8614 13.4166 24.5074 12.68 23.9499 12.1451C23.3924 11.6102 22.6686 11.3145 21.9206 11.3146L21.9226 13.488C22.172 13.488 22.4127 13.5867 22.5986 13.7651C22.7844 13.9436 22.9023 14.1893 22.9298 14.4552L24.9441 14.2139ZM23.4992 33.0489C23.9267 33.0487 24.3493 32.9517 24.7394 32.7645C25.1295 32.5772 25.4785 32.3038 25.7634 31.9621C26.0484 31.6204 26.2629 31.2181 26.3931 30.7814C26.5232 30.3448 26.5681 29.8836 26.5208 29.428L24.5064 29.6692C24.5224 29.8213 24.5082 29.973 24.4649 30.1188C24.4216 30.2646 24.35 30.3989 24.255 30.513C24.1599 30.6271 24.0434 30.7183 23.9132 30.7808C23.783 30.8433 23.6419 30.8755 23.4992 30.8755V33.0489ZM0.686641 29.428C0.639318 29.8838 0.682192 30.3451 0.812461 30.7819C0.94273 31.2187 1.15746 31.6212 1.44263 31.9629C1.7278 32.3046 2.07698 32.578 2.46737 32.7651C2.85777 32.9523 3.28058 33.049 3.70819 33.0489V30.8755C3.56572 30.8755 3.42484 30.8433 3.29476 30.7809C3.16468 30.7186 3.04832 30.6275 2.95328 30.5137C2.85823 30.3999 2.78664 30.2658 2.74317 30.1203C2.6997 29.9748 2.68533 29.8211 2.70101 29.6692L0.686641 29.4301V29.428ZM4.27764 14.453C4.30554 14.1875 4.42368 13.9423 4.60947 13.7643C4.79526 13.5863 5.03772 13.4879 5.28685 13.488V11.3146C4.53917 11.315 3.81584 11.6109 3.25879 12.1458C2.70175 12.6807 2.34602 13.417 2.26328 14.2139L4.27764 14.453ZM8.5374 9.14115V8.05443H6.51087V9.14115H8.5374ZM18.67 8.05443V9.14115H20.6965V8.05443H18.67ZM13.6037 2.62085C14.9474 2.62085 16.236 3.19332 17.1861 4.21231C18.1362 5.2313 18.67 6.61336 18.67 8.05443H20.6965C20.6965 6.03693 19.9493 4.10205 18.6191 2.67546C17.2889 1.24887 15.4848 0.447418 13.6037 0.447418V2.62085ZM8.5374 8.05443C8.5374 6.61336 9.07117 5.2313 10.0213 4.21231C10.9714 3.19332 12.26 2.62085 13.6037 2.62085V0.447418C11.7226 0.447418 9.91848 1.24887 8.58832 2.67546C7.25815 4.10205 6.51087 6.03693 6.51087 8.05443H8.5374Z"
                          fill="black"
                        />
                      </svg>
                    </Badge>
                  </Link>
                </div>
                <div className="Login_Logout" onClick={() => logout(true)}>
                  <Button className="Button">Logout</Button>
                </div>
              </div>
            ) : (
              <div className="Login_Logout">
                <Link
                  to="/login"
                  style={{ textDecoration: "none", color: "black" }}
                >
                  <Button className="Button">Login</Button>
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </HeaderAlign>
  );
};

export default Header10;

const HeaderAlign = styled.div`
  .Header_Main {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    gap: 40px;
    /* background: transparent; */
    position: absolute;
    width: 100%;
    padding: 30px 0;
    z-index: 999;
    top: 0;
  }

  .Header_Middle .Header_List {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    margin-bottom: 0px;
  }

  .Header_Middle .Header_List li {
    color: #2f4076;
    font-family: Euclid Circular A;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 25.2px;
  }

  .Header_Right .Header_Icons {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 30px;
  }

  .Login_Logout .Button {
    display: inline-flex;
    padding: 16px 24px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 24px;
    background: #fff;
    border: none;
    outline: none;
  }

  .Login_Logout .Button:hover {
    background: #fff;
    color: #2f4076;
  }

  .Header_Left .Header_Logo {
    width: 136.199px;
    flex-shrink: 0;
  }
`;
